import { Stack } from "@mantine/core"
import { SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { InlineBanner, InlineBannerProps } from "~/components/InlineBanner.tsx"
import { MaterialMappingWrapper } from "~/pages/Brand/OrganizationSettings/Mapping/Materials"
import { ProductMappingWrapper } from "~/pages/Brand/OrganizationSettings/Mapping/Product"
import { StandardMappingWrapper } from "~/pages/Brand/OrganizationSettings/Mapping/Standards"

type MappingProps = {
  count: number
}

export function Mapping({ count }: MappingProps) {
  const { t } = useTranslation("organizationSettings")

  const bannerConfig: InlineBannerProps = {
    type: count > 0 ? "error" : "success",
    message: count > 0 ? t("mapping.pending", { count }) : t("mapping.success"),
  }
  return (
    <>
      <SectionHeader
        title={t("mapping.title")}
        subtitle={t("mapping.pageDescription")}
      />
      <Stack>
        <InlineBanner {...bannerConfig} />
        <ProductMappingWrapper />
        <MaterialMappingWrapper />
        <StandardMappingWrapper />
      </Stack>
    </>
  )
}
